/* src/app/shared/components/main-title/main-title.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: block;
  width: 100%;
}
.title-action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
}
.title-action-bar__title {
  margin: 0;
  flex: none;
}
.title-action-bar__action {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  margin-left: auto;
}
.title-action-bar__last-update {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-text-medium);
  line-height: 1;
  margin: 0;
  text-align: right;
}
.title-action-bar__opf-disclaimer {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: 400;
  color: var(--cds-text-medium);
  line-height: 1.5;
  margin: 0;
  text-align: right;
  word-break: break-word;
}
h2 {
  font-size: 28px;
  color: var(--cds-text-strong);
  margin: 0;
}
/*# sourceMappingURL=main-title.component.css.map */
